import React from 'react';
import Profile from 'components/Profile';

export default function ProfilePage() {
  return <Profile />;
}

ProfilePage.displayName = 'ProfilePage';
